jQuery(function ($) {

  $('.magnific-popup-group').magnificPopup({
    delegate: '.magnific-popup-group__target',
    type: 'inline',
    removalDelay: 900,
    preloader: false,
    gallery: { //ギャラリー表示にする
      enabled: true,
      preload: [1, 1]
    },
    callbacks: {
      beforeOpen: function () {
        this.st.mainClass = this.st.el.attr('data-effect');
      }
    }
  });
  $('.magnific-popup-group_staff').magnificPopup({
    delegate: '.magnific-popup-group__target',
    type: 'inline',
    removalDelay: 900,
    preloader: false,
    gallery: { //ギャラリー表示にする
      enabled: true,
      preload: [1, 1]
    },
    callbacks: {
      beforeOpen: function () {
        this.st.mainClass = this.st.el.attr('data-effect');
      }
    }
  });
  $('.magnific-popup-group_seminar').magnificPopup({
    delegate: '.magnific-popup-group__target',
    type: 'inline',
    removalDelay: 900,
    preloader: false,
    callbacks: {
      beforeOpen: function () {
        this.st.mainClass = this.st.el.attr('data-effect');
      }
    }
  });
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

});
